module.exports = __webpack_public_path__ + "img/product-s618-3000-1.6e0d83ec.png";